import React from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { getDatabase } from "firebase/database";
import { doc, getDoc } from "firebase/firestore";
import "./Post.css";
import NavBar from "../Components/NavBar";
import NavBarHome from "../Components/NavBarHome";

function Post ()  {
    const { id } = useParams();
    const navigate = useNavigate();

    const [title, setTitle] = React.useState("");
    const [text, setText] = React.useState("");
    const [btext, setBText] = React.useState("");
    const [b2text, setB2Text] = React.useState("");
    const [time, setTime] = React.useState("");
    const [yt, setYt] = React.useState("");
    const [topImg, setTopImg] = React.useState("");
    const [botImg, setBotImg] = React.useState("");

    React.useEffect(() => {
        const fetch = async () => {
            const docRef = doc(getDatabase, "Posts", id);
            const docSnap = await getDoc(docRef);
            
            if (docSnap.exists()) {
                const data = docSnap.data();
                setTitle(data.Title);
                setText(data.Text);
                setBText(data.Body_Text);
                setB2Text(data.Body2_Text);
                setYt(data.YoutubeLink);
                setTopImg(data.T_IMG);
                setBotImg(data.B_IMG);
                setTime(data.Time.toDate().toString());
            } else {
                navigate("/404");
            }
        }
        fetch();
    }, [id, navigate])
    
    

    return (
        <>
            <NavBarHome/>
            <h1>{title}</h1>
            {!!yt  ?(
            <div className="wrapper-wrapper">
                <div className="player-wrapper">
                    <iframe 
                        className="vid"
                        src={yt.replace('watch?v=', 'embed/')}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
            ) : (null)
            }
            <p>{text}</p>
            {!!topImg ? (<img className = "postIMG" src={topImg} alt="post top"></img>) : (null)}
            
            <p>{btext}</p>
            {!!botImg ? (<img className = "postIMG" src={botImg} alt="post bottom"></img>) : (null)}
            <p>{b2text}</p>
            <footer>Posted at: {time}</footer>
            
        </>
    )
}

export default Post;
